var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#ff4b55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.103 220.691H291.31v-61.793a8.829 8.829 0 0 0-8.828-8.828h-52.966a8.829 8.829 0 0 0-8.828 8.828v61.793h-61.793a8.829 8.829 0 0 0-8.828 8.828v52.966a8.829 8.829 0 0 0 8.828 8.828h61.793v61.793a8.829 8.829 0 0 0 8.828 8.828h52.966a8.829 8.829 0 0 0 8.828-8.828v-61.795h61.793a8.829 8.829 0 0 0 8.828-8.828v-52.966c0-4.874-3.953-8.826-8.828-8.826z",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh);
export default __webpack_public_path__ + "static/media/ch.38cd5784dcc556ce0dfd34228f294977.svg";
export { ForwardRef as ReactComponent };